





















import Vue, { PropType } from 'vue'
interface ObjectData {
    temp: number;
}

const WeatherCard = Vue.extend({
    props: {
        data: Object as PropType<ObjectData>,
        location: String,
    },

    computed: {
        // need annotation
        temp(): number {
            return parseFloat((this.data.temp - 273).toFixed(2))
        },
    },
})

export default WeatherCard
